import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Droplet, Heart, Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { useLanguage, getPageTexts } from '../i18n/pageTranslations';

const MedicinaIntegrativa = () => {
  const lang = useLanguage();
  const t = getPageTexts('medicinaIntegrativa', lang);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const iconos = [Droplet, Heart, Sparkles];

  return (
    <div className="min-h-screen bg-[#FDFBF8]">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 bg-[#FDFBF8]">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.category}</p>
              <h1 className="font-serif text-5xl md:text-6xl text-[#1C1C1A] mb-6 leading-tight">
                {t.title}
              </h1>
              <div className="w-20 h-[2px] bg-[#B8975A] mb-8"></div>
              <p className="text-lg text-[#4A4845] leading-relaxed mb-8">
                {t.heroDesc}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/contacto"
                  className="inline-flex items-center justify-center gap-2 bg-[#B8975A] text-white px-8 py-4 text-sm tracking-wider uppercase hover:bg-[#96784a] transition-colors"
                >
                  {t.requestAssessment}
                  <ArrowRight size={16} />
                </Link>
                <a 
                  href="tel:+34952764547"
                  className="inline-flex items-center justify-center gap-2 border border-[#1C1C1A] text-[#1C1C1A] px-8 py-4 text-sm tracking-wider uppercase hover:bg-[#1C1C1A] hover:text-white transition-colors"
                >
                  <Phone size={16} />
                  {t.callNow}
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#B8975A]"></div>
              <img 
                src="/images/placeholder-tratamiento.svg"
                alt={t.title}
                className="w-full h-auto"
              />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#B8975A]"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section className="py-20 bg-[#1C1C1A]">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="text-center mb-16">
            <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.servicesTitle}</p>
            <h2 className="font-serif text-4xl text-white">{t.servicesSubtitle}</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {t.services && t.services.map((servicio, index) => {
              const Icon = iconos[index] || Sparkles;
              return (
                <div key={index} className="p-8 border border-[#B8975A]/30 hover:border-[#B8975A] transition-colors text-center">
                  <Icon size={40} className="text-[#B8975A] mx-auto mb-6" />
                  <h3 className="font-serif text-2xl text-white mb-4">{servicio.title}</h3>
                  <p className="text-white/70">{servicio.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* IV Drips */}
      <section className="py-20 bg-[#F0EDE7]">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="text-center mb-16">
            <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.dripsTitle}</p>
            <h2 className="font-serif text-4xl text-[#1C1C1A]">{t.dripsSubtitle}</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {t.drips && t.drips.map((drip, index) => (
              <div key={index} className="bg-white p-6 border-b-2 border-[#B8975A]">
                <h3 className="font-serif text-xl text-[#1C1C1A] mb-2">{drip.name}</h3>
                <p className="text-[#4A4845] text-sm">{drip.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#FDFBF8]">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <h2 className="font-serif text-4xl text-[#1C1C1A] mb-6">
            {t.ctaTitle}
          </h2>
          <p className="text-[#4A4845] mb-10">
            {t.ctaDesc}
          </p>
          <Link 
            to="/contacto"
            className="inline-flex items-center gap-2 bg-[#B8975A] text-white px-10 py-4 text-sm tracking-wider uppercase hover:bg-[#96784a] transition-colors"
          >
            {t.contact}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default MedicinaIntegrativa;
